// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
import AutoLoanIndexDisbursementTypes from './auto-loan-index-disbusement.types';

/*********** FETCH PARTICULAR LOAN INDEX START ************************ */
export const fetchParticularAutoLoanIndexDetailsStart = (addData: any) => ({
	type: AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_START,
	payload: addData,
});

export const fetchParticularAutoLoanIndexDetailsSuccess = (successData: any) => ({
	type: AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchParticularAutoLoanIndexDetailsFailure = (failureData: unknown) => ({
	type: AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchParticularAutoLoanIndexDetailsResponseResetStart = () => ({
	type: AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_RESPONSE_RESET,
});

export const fetchParticularAutoLoanIndexDetailsResponseChanged = () => ({
	type: AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_RESPONSE_CHANGED,
});
/*********** FETCH PARTICULAR LOAN INDEX END ************************ */

/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
export const createHDFCCreateIndividualQRCodeStart = (fetchData: any) => ({
	type: AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_START,
	payload: fetchData,
});
export const createHDFCCreateIndividualQRCodeSuccess = (successData: any) => ({
	type: AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_SUCCESS,
	payload: successData,
});
export const createHDFCCreateIndividualQRCodeFailure = (failureData: unknown) => ({
	type: AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_FAILURE,
	payload: failureData,
});
export const createHDFCCreateIndividualQRCodeResponseReset = () => ({
	type: AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_RESPONSE_RESET,
});
export const createHDFCCreateIndividualQRCodeResponseChanged = () => ({
	type: AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_RESPONSE_CHANGED,
});
/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

/*********** GROUP WISE AUTO LOAN START ************************ */
export const groupWiseAutoLoanListStart = (payload: any) => ({
	type: AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_START,
	payload,
});

export const groupWiseAutoLoanListSuccess = (data: any) => ({
	type: AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_SUCCESS,
	payload: data,
});

export const groupWiseAutoLoanListFailure = (error: any) => ({
	type: AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_FAILURE,
	payload: error,
});

export const groupWiseAutoLoanListResponseReset = () => ({
	type: AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_RESPONSE_RESET,
});

export const groupWiseAutoLoanListResponseChanged = () => ({
	type: AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_RESPONSE_CHANGED,
});

/*********** GROUP WISE AUTO LOAN END ************************ */

/** ***************** AUTO LOAN DISBURSEMENT START *********************** */
export const addAutoLoanIndexDisbursementStart = (getData: any) => ({
	type: AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_START,
	payload: getData,
});

export const addAutoLoanIndexDisbursementSuccess = (successData: any) => ({
	type: AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_SUCCESS,
	payload: successData,
});

export const addAutoLoanIndexDisbursementFailure = (failureData: any) => ({
	type: AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_FAILURE,
	payload: failureData,
});

export const addAutoLoanIndexDisbursementResponseReset = () => ({
	type: AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_RESPONSE_RESET,
});

export const addAutoLoanIndexDisbursementResponseChanged = () => ({
	type: AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_RESPONSE_CHANGED,
});
/** ***************** AUTO LOAN DISBURSEMENT END *********************** */

/** ***************** AUTO LOAN SCHEDULE START *********************** */
export const fetchAutoLoanScheduleStart = (getData: any) => ({
	type: AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_START,
	payload: getData,
});

export const fetchAutoLoanScheduleSuccess = (successData: any) => ({
	type: AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_SUCCESS,
	payload: successData,
});

export const fetchAutoLoanScheduleFailure = (failureData: any) => ({
	type: AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_FAILURE,
	payload: failureData,
});

export const fetchAutoLoanSchedulResponseReset = () => ({
	type: AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_RESPONSE_RESET,
});

export const fetchAutoLoanSchedulResponseChanged = () => ({
	type: AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_RESPONSE_CHANGED,
});
/** ***************** AUTO LOAN SCHEDULE END *********************** */

/** ***************** DELETE PARTICULAR AUTO LOAN INDEX START *********************** */
export const deleteParticularAutoLoanIndexStart = (getData: any) => ({
	type: AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_START,
	payload: getData,
});

export const deleteParticularAutoLoanIndexSuccess = (successData: any) => ({
	type: AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const deleteParticularAutoLoanIndexFailure = (failureData: any) => ({
	type: AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const deleteParticularAutoLoanIndexResponseReset = () => ({
	type: AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_RESPONSE_RESET,
});

export const deleteParticularAutoLoanIndexResponseChaanged = () => ({
	type: AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_RESPONSE_CHANGED,
});
/** ***************** DELETE PARTICULAR AUTO LOAN INDEX END *********************** */
